<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'

  const props = defineProps<{
    title: string
    class?: HTMLAttributes['class']
  }>()
</script>
<template>
  <div
    role="separator"
    :class="
      cn(
        'relative flex w-full items-center px-4 pt-3 text-xs text-slate-400',
        props.class
      )
    "
  >
    {{ title }}
  </div>
</template>
